import { useQuery } from "@tanstack/react-query";

import { api } from "../../lib/api";
import { queryKeys } from "../../lib/queryKeys";
import { Panel } from "../../components/ui/Panel";

/**
 * Whether the Lane integration is working.
 *
 * No board is configured here on purpose -- which board a task belongs on is
 * decided per task, by the agent raising it, so there is nothing to set. This
 * panel exists to answer the only question an admin has: is the key working.
 */
export function LaneSettings() {
  const status = useQuery({
    queryKey: queryKeys.laneStatus,
    queryFn: api.laneStatus,
  });

  return (
    <Panel
      collapsible
      title="Lane"
    >
      {status.isLoading ? (
        <p className="text-xs text-muted">Checking\u2026</p>
      ) : status.data?.enabled ? (
        <p className="text-xs text-sla-ok">
          Connected. Agents choose a board when they raise a task.
        </p>
      ) : status.data?.error ? (
        <p className="text-xs text-red-600">
          Configured, but the key was rejected: {status.data.error}
        </p>
      ) : (
        <p className="text-xs text-muted">
          Not configured. Set <code>LANE_API_TOKEN</code> to a Lane API key with
          read_write access, then restart the API.
        </p>
      )}
    </Panel>
  );
}
